/* ============================================================
   Brockett Built — cart-drawer.js
   AJAX cart drawer with free-shipping bar, qty updates, upsells
   ============================================================ */

(function () {
  'use strict';

  const drawer = document.getElementById('cart-drawer');
  const overlay = document.getElementById('drawer-overlay');
  if (!drawer) return;

  function openCart() {
    drawer.setAttribute('data-open', 'true');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.setAttribute('data-open', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    drawer.setAttribute('data-open', 'false');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.setAttribute('data-open', 'false');
    document.body.style.overflow = '';
  }

  // Open / close triggers
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-action="open-cart"]')) { e.preventDefault(); openCart(); }
    if (e.target.closest('[data-action="close-cart"]')) { e.preventDefault(); closeCart(); }
  });
  document.addEventListener('cart:open', openCart);
  document.addEventListener('cart:close', closeCart);

  // Refresh cart drawer from /cart.js + re-render
  async function refresh() {
    try {
      const res = await fetch(window.theme.routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } });
      const cart = await res.json();
      render(cart);
      // Update bubble in header
      document.querySelectorAll('[data-action="open-cart"]').forEach(btn => {
        btn.setAttribute('data-count', cart.item_count);
      });
    } catch (e) {
      console.error('cart refresh failed', e);
    }
  }

  function render(cart) {
    const head = drawer.querySelector('[data-cart-count]');
    if (head) head.textContent = `Cart (${cart.item_count})`;

    const subtotal = drawer.querySelector('[data-cart-subtotal]');
    if (subtotal) subtotal.textContent = window.formatMoney(cart.total_price);

    // Free shipping bar
    const threshold = window.theme.strings.freeShipThreshold || 50000;
    const progress = Math.min(100, (cart.total_price / threshold) * 100);
    const fill = drawer.querySelector('[data-shipping-fill]');
    const msg = drawer.querySelector('[data-shipping-message]');
    const prog = drawer.querySelector('[data-shipping-progress]');
    if (fill) fill.style.width = progress + '%';
    if (prog) prog.innerHTML = `${window.formatMoney(cart.total_price)} / ${window.formatMoney(threshold)}`;
    if (msg) msg.textContent = cart.total_price >= threshold
      ? (window.theme.strings.freeShipUnlocked || 'Free shipping unlocked')
      : (window.theme.strings.freeShipMessage || 'Free shipping at threshold');

    // Items
    const itemsEl = drawer.querySelector('[data-cart-items]');
    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = `
        <div style="padding: 48px 0; text-align: center; color: var(--ink-3);">
          <p class="eyebrow" style="margin-bottom: 16px;">Your cart is empty</p>
          <a href="/" class="btn btn--ghost">Continue shopping</a>
        </div>`;
      return;
    }

    itemsEl.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-line-key="${item.key}">
        <a href="${item.url}"><img src="${item.image ? item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_160x$1$2') : ''}" width="80" height="80" alt="${escapeHTML(item.title)}"></a>
        <div>
          <div class="cart-item__title">${escapeHTML(item.product_title.replace('Brockett Built ', ''))}</div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${escapeHTML(item.variant_title)}</div>` : ''}
          <div class="cart-item__qty" data-qty>
            <button type="button" data-qty-change="-1" data-line-key="${item.key}" aria-label="Decrease">−</button>
            <span data-qty-value>${item.quantity}</span>
            <button type="button" data-qty-change="1" data-line-key="${item.key}" aria-label="Increase">+</button>
          </div>
          <a href="javascript:void(0)" class="cart-item__remove" data-remove data-line-key="${item.key}">Remove</a>
        </div>
        <div class="cart-item__price">${window.formatMoney(item.final_line_price)}</div>
      </div>
    `).join('');
  }

  function escapeHTML(s) {
    return String(s || '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  // Qty change handler (delegated at document level so it works on /cart too, not just the drawer)
  document.addEventListener('click', async (e) => {
    const qtyBtn = e.target.closest('[data-qty-change], [data-qty-step]');
    const removeBtn = e.target.closest('[data-remove]');

    if (qtyBtn) {
      // Skip if this is the PDP qty stepper inside a product form — theme.js handles those.
      if (qtyBtn.closest('[data-product-form]')) return;

      const lineEl = qtyBtn.closest('[data-line-key]');
      const lineKey = qtyBtn.dataset.lineKey || (lineEl && lineEl.dataset.lineKey);
      if (!lineKey) return;
      const delta = parseInt(qtyBtn.dataset.qtyChange || qtyBtn.dataset.qtyStep, 10);
      if (isNaN(delta)) return;
      const valEl = qtyBtn.parentElement.querySelector('[data-qty-value]');
      const currentVal = valEl ? (valEl.value !== undefined && valEl.value !== '' ? valEl.value : valEl.textContent) : '0';
      const newQty = Math.max(0, parseInt(currentVal, 10) + delta);
      e.preventDefault();
      await updateLine(lineKey, newQty);
    }

    if (removeBtn) {
      // Only intercept if it has a data-line-key context — otherwise let the link navigate normally.
      const lineEl = removeBtn.closest('[data-line-key]');
      const lineKey = removeBtn.dataset.lineKey || (lineEl && lineEl.dataset.lineKey);
      if (!lineKey) return;
      e.preventDefault();
      await updateLine(lineKey, 0);
    }
  });

  async function updateLine(lineKey, quantity) {
    try {
      await fetch(window.theme.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity })
      });
      await refresh();
    } catch (e) {
      console.error('cart update failed', e);
    }
  }

  document.addEventListener('cart:update', refresh);
})();
